export default __webpack_public_path__ + "static/media/textbook.cc5e2be5.svg";